import {
  Geocodes,
  GeocodesModel
} from 'components/discovery/store-locator/typing/google-geocoder.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const GOOGLE_GEOCODER_API = Symbol('GOOGLE_GEOCODER_API')

export class GoogleGeocodeRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = {
    Accept: 'application/json',
    RequestMode: 'no-cors'
  }
  controller: AbortController = new AbortController()

  constructor(address: string, mapsApikey: string, proxy: string) {
    this.endpointUrl = new URL(proxy, window.location.href)

    const proxyUrl = new URL('https://maps.googleapis.com/maps/api/geocode/json')
    proxyUrl.searchParams.set('address', address)
    proxyUrl.searchParams.set('key', mapsApikey)

    this.endpointUrl.searchParams.set('url', proxyUrl.toString())
  }
}

@registerDependency(FAKE, GOOGLE_GEOCODER_API)
export class FakeGoogleGeocoderApi {

  coordinates: Geocodes = new GeocodesModel()
  requests: GoogleGeocodeRequest[] = []

  geocode(request: GoogleGeocodeRequest) {
    this.requests.push(request)
    return Promise.resolve(this.coordinates)
  }
}

@registerDependency(REAL, GOOGLE_GEOCODER_API)
export class GoogleGeocodeApi {

  async geocode(request: GoogleGeocodeRequest): Promise<unknown> {
    return await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers
    }).then(r => r.json())
  }
}
